import { ChangeDetectorRef, Component } from '@angular/core';
import { catchError, finalize, tap } from 'rxjs';
import { AppService } from '../../../../app.service';
import { isArrayWithData } from '../../../../utilities/array.helpers';
import { ReportsService } from '../../../../services/reports/reports.service';
import moment from 'moment';

@Component({
    selector: 'app-payments-by-channel',
    templateUrl: './payments-by-channel.component.html',
    styleUrl: './payments-by-channel.component.css',
})
export class PaymentsByChannelComponent {
    isSideBarVisible: boolean = false;
    isDeleteModalVisible: boolean = false;
    toDeleteItem: any;
    editedId: number = 0;
    selectedCreditorId: string = '';
    selectedCreditorCompanyName: string = '';
    results!: any[];

    firstName: string = '';
    lastName: string = '';
    email: string = '';
    creditors: any[] = [];
    hasClickedSearch: boolean = false;

    fromDate: Date = new Date();
    toDate: Date = new Date();

    public constructor(
        private appService: AppService,
        private reportsService: ReportsService,
        private cdr: ChangeDetectorRef,
    ) {}

    ngOnInit() {}

    get hasTableData(): boolean {
        return isArrayWithData(this.results);
    }

    onSelectCreditor(event: any) {
        this.hasClickedSearch = false;
        this.selectedCreditorId = event.CreditorId;
        this.selectedCreditorCompanyName = event.CompanyName;
    }

    get isGenerateButtonDisabled() {
        return !this.selectedCreditorId || !this.fromDate || !this.toDate;
    }

    onGenerate() {
        if (this.isGenerateButtonDisabled) {
            return;
        }

        this.appService.isShowPageSpinner = true;

        this.reportsService
            .generatePaymentsByChannel(
                this.selectedCreditorId,
                this.fromDate,
                this.toDate,
            )
            .pipe(
                catchError(this.appService.handleError),
                finalize(() => {
                    this.appService.isShowPageSpinner = false;
                }),
            )
            .subscribe({
                next: (response: any) => {
                    this.results = response;

                    this.appService.showCommonMessageDialog(
                        'Success',
                        'Payments by channel report generated successfully.',
                    );

                    this.cdr.detectChanges();
                },
            });
    }

    onExport() {
        if (this.isGenerateButtonDisabled) {
            return;
        }

        this.reportsService
            .downloadPaymentsByChannelReport(
                this.selectedCreditorId,
                this.fromDate!,
                this.toDate!,
            )
            .subscribe({
                next: (blob) => {
                    if (blob) {
                        const downloadUrl = window.URL.createObjectURL(blob);
                        const a = document.createElement('a');

                        a.href = downloadUrl;
                        a.download = `PaymentsByChannel_${this.selectedCreditorCompanyName}_${moment(this.fromDate).format('YYYY-MM-DD')}_to_${moment(this.toDate).format('YYYY-MM-DD')}.csv`;

                        document.body.appendChild(a);
                        a.click();
                        document.body.removeChild(a);

                        window.URL.revokeObjectURL(downloadUrl);
                    }
                },
                error: (error) => {
                    console.error('Payments by Channel download failed', error);
                },
            });
    }
}
